import React from 'react';
import { Helmet } from 'react-helmet';

const TermsAndConditions = () => {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", lineHeight: '1.6', color: '#333', background: '#f5f5f5', minHeight: '100vh' }}>
      <Helmet>
        <title>Terms and Conditions | SugarHathi</title>
        <meta name="description" content="Terms and conditions for using the SugarHathi platform, operated by Villgrains FarmTech Private Limited." />
      </Helmet>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', background: 'white', minHeight: '100vh' }}>

        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '3px solid #2ecc71' }}>
          <h1 style={{ fontSize: '2.5rem', color: '#2ecc71', margin: '0 0 10px 0', padding: 0 }}>Terms & Conditions</h1>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: '0 0 5px 0' }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: 0 }}>Last Updated: June 7, 2026</p>
        </div>

        <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
          These Terms and Conditions govern your access to and use of <strong style={{ color: '#2c3e50' }}>www.sugarhathi.com</strong> operated
          by <strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong>. By using our Platform, you agree to these Terms.
        </p>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>1. Eligibility</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            You must be at least 18 years of age to use this Platform. Business users must hold valid GST
            registration where applicable.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>2. User Accounts</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            You are responsible for maintaining the confidentiality of your account credentials including
            your PIN. Notify us immediately of any unauthorized access at <strong style={{ color: '#2c3e50' }}>info@villagegrains.com</strong>.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>3. Orders and Transactions</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            All orders are subject to acceptance and availability. Prices are inclusive of applicable GST.
            TDS deductions must be declared at the time of booking.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>4. Payments</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Payments are processed securely through <strong style={{ color: '#2c3e50' }}>Razorpay</strong> (Razorpay Software Private Limited),
            a PCI-DSS compliant payment gateway. We do not store card numbers, CVV, or net banking credentials
            on our servers.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>5. Cancellations and Refunds</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Confirmed bookings with payment cannot be cancelled. In case of inability to supply,
            full refund will be processed within 7 working days. Please refer to our
            <a href="/refund" style={{ color: '#2ecc71', marginLeft: '5px' }}>Refund Policy</a> for details.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>6. Delivery and Logistics</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Delivery timelines are estimates and subject to road and regulatory conditions.
            Risk of goods passes to buyer upon loading confirmation at factory.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>7. Prohibited Conduct</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            You agree not to submit false information, manipulate prices, share platform credentials,
            or engage in any activity that violates applicable law.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>8. Intellectual Property</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            All content, trademarks, and technology on this Platform are owned by Villgrains FarmTech
            Private Limited. Unauthorized use is prohibited.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>9. Limitation of Liability</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            SugarHathi is a technology platform only. We are not liable for trade disputes between parties,
            physical damage to goods, delivery delays, or banking system failures.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>10. Governing Law</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            These Terms are governed by the laws of India. Disputes shall be subject to the exclusive
            jurisdiction of courts in Hyderabad, Telangana.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>11. Contact Us</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
            <p style={{ marginBottom: '10px' }}>101B, Vishnu Acharya Nivas, Road No 3, Journalist Colony, Banjara Hills, Hyderabad, Telangana - 500034</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>WhatsApp:</strong> +91 79899 53468</p>
          </div>
        </section>

        <div style={{ textAlign: 'center', marginTop: '50px', paddingTop: '30px', borderTop: '2px solid #e0e0e0', color: '#666', fontSize: '0.9rem' }}>
          <p style={{ marginBottom: '5px' }}>&copy; 2026 Villgrains FarmTech Private Limited. All rights reserved.</p>
          <p style={{ margin: 0 }}>Trading as SugarHathi</p>
        </div>

      </div>
    </div>
  );
};

export default TermsAndConditions;
